import { useTranslation } from "react-i18next";
import PageLayout from "../components/PageLayout";

import styles from "./pages.module.css";


export default function Results() {
    const { t } = useTranslation();

    return (
        <PageLayout>
            <section className={styles.section}>
                <h2 className={styles.title}>{t("resultsPage.title")}</h2>
                <p className={styles.text}>{t("resultsPage.description")}</p>
            </section>
        </PageLayout>
    );
}